import { useState } from 'react';

export default () => {
	const [ key, setKey ] = useState(0);
	const rerender = () => setKey(Math.random());

	return { key, rerender };
};
